"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Pencil"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "Vector",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M10.586 2.47134C10.961 2.09638 11.4696 1.88574 12 1.88574C12.5303 1.88574 13.0389 2.09638 13.414 2.47134L13.5286 2.58602C13.9036 2.96109 14.1142 3.46973 14.1142 4.00008C14.1142 4.53044 13.9036 5.03908 13.5286 5.41415L12.3706 6.57354L5.80464 13.1392C5.71931 13.2246 5.61239 13.2852 5.49531 13.3145L2.82864 13.9812C2.71692 14.0092 2.59985 14.0078 2.48885 13.9771C2.37785 13.9463 2.2767 13.8874 2.19526 13.8059C2.11382 13.7245 2.05487 13.6233 2.02415 13.5123C1.99343 13.4013 1.99199 13.2843 2.01998 13.1725L2.68664 10.5057C2.71601 10.3886 2.77661 10.2817 2.86198 10.1964L9.46598 3.59206L10.586 2.47201V2.47134ZM12.4713 3.41406C12.3463 3.28907 12.1768 3.21886 12 3.21886C11.8232 3.21886 11.6537 3.28907 11.5286 3.41406L10.8713 4.07142L11.908 5.14947L12.586 4.47144C12.711 4.34642 12.7812 4.17687 12.7812 4.00008C12.7812 3.8233 12.711 3.65375 12.586 3.52873L12.4713 3.41406ZM10.9646 6.09219L9.92798 5.0148L3.93531 11.0084L3.58264 12.4178L4.99264 12.0651L10.9653 6.09219H10.9646Z",
    fill: fill
  })));
};

exports["default"] = _default;